<template>
  <section class="input-wrap">
    <div class="ip-body">
      <div
        :class="{'offering-item':true,active:showType===item,sended:sended.includes(item)}"
        v-for="item in Object.keys(offering)"
        :key="item"
        :amount="offeringAmount[item]||1"
        @click="selectOffering(item)"
      >
        <img :src="`/offering/${item}.png`" alt />
      </div>
    </div>
    <div
      v-if="showType"
      id="showOfferAmountBg"
      @click="showOfferAmountBg($event)"
      @touchstart="showOfferAmountBg($event)"
    >
      <div v-if="sendingType" :class="{sendAnimate:true}">
        <img :src="`/offering/${sendingType}.png`" alt />
      </div>
      <div :class="{showOfferingAmount:true,active:showType}">
        <div class="offeringAmount">{{offeringAmount[showType]}}</div>
        <div class="offeringAmount">
          <span>{{offering[showType].label}}</span>
        </div>
        <div
          class="submitOffering"
          v-if="!sended.includes(showType)"
          @click="sendOffering(showType)"
        >{{offering[showType].submit_text}}</div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios";

export default {
  name: "Sender",
  data() {
    return {
      sended: [],
      sendingType: null,
      offering: {
        candle: {
          label: "蜡烛",
          submit_text: "点燃"
        },
        flower: {
          label: "鲜花",
          submit_text: "摆放"
        },
        peach: {
          label: "水果",
          submit_text: "摆放"
        },
        pine: {
          label: "盆景",
          submit_text: "摆放"
        },
        seedling: {
          label: "幼苗",
          submit_text: "栽种"
        },
        woodhorse: {
          label: "木马玩具",
          submit_text: "摆放"
        }
      },
      offeringAmount: {},
      showType: null
    };
  },
  computed: {
    api() {
      return this.$store.state.api;
    }
  },
  methods: {
    showOfferAmountBg(e) {
      console.log(e.target.id, "evnet");
      if (e.target.id === "showOfferAmountBg") {
        this.showType = null;
      }
    },
    selectOffering(type) {
      this.showType = this.showType === type ? null : type;
    },
    async sendOffering(type) {
      if (!type) return;
      this.sendingType = type;
      let { id } = this.$route.query;
      id = id || 1;
      const response = await axios.post(`${this.api}/v1/offering`, {
        article_id: id,
        offering: type
      });
      console.log(response, "response");
      await this.getOffering();
      this.sended.push(type);
      const self = this;
      this.$nextTick(() => {
        setTimeout(() => {
          self.sendingType = null;
        }, 1000);
      });
    },
    async getOffering() {
      const { query } = this.$route;
      console.log(query, "query");
      const { id } = query;
      const response = await axios.get(`${this.api}/v1/offering`, {
        params: { id }
      });

      const { data } = response;
      const offering = data.data;
      const offerMap = {};
      offering.forEach(ele => {
        offerMap[ele.type] = ele.amount;
      });
      this.$set(this, "offeringAmount", offerMap);
    }
  },
  async mounted() {
    await this.getOffering();
  }
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 600px) {
  .showOfferingAmount {
    width: 90%;
    padding: 0 5%;
  }
}
.input-wrap {
  margin: 0 auto;
  position: fixed;
  bottom: 0;
  width: 100vw;
  z-index: 1;
  .ip-body {
    margin: 0 auto;
    background: white;
    width: 100%;
    max-width: 400px;
    height: 50px;
    display: flex;
    flex-direction: row;
    box-shadow: 1px 1px 20px 0px #ededed;
    justify-content: space-around;
    .offering-item {
      height: 50px;
      width: 50px;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
      img {
        height: 30px;
        padding: 10px;
        transition: all 0.3s ease-in-out;
      }
      &.active {
        background: #ededed;
        img {
          transform: scale(1.2);
        }
      }
      &.sended {
        opacity: 0.4;
      }
    }
  }
  #showOfferAmountBg {
    width: 100vw;
    z-index: 2;
    height: calc(100vh - 50px);
    position: fixed;
    left: 0;
    top: 0;
    .sendAnimate {
      will-change: auto;
      pointer-events: none;
      width: 50vw;
      height: 50vw;
      position: absolute;
      animation: ash 1.5s forwards ease-in-out;
      img {
        width: 60%;
        padding: 20%;
      }
    }
    .showOfferingAmount {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      max-width: 340px;
      height: 50px;
      width: 100%;
      margin: 0 auto;
      padding: 0 30px;
      background: white;
      transition: all 1s ease-in-out;
      box-shadow: 1px 1px 20px 0px #ededed;
      // border-radius: 50vh;
      animation: jumpout 0.2s forwards ease-in-out;
      .offeringAmount {
        padding: 10px;
        font-weight: 100;
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-shadow: 1px 1px 5px #ddeded;
      }
      .submitOffering {
        cursor: pointer;
        padding: 10px;
        font-size: 1rem;
        margin: 10px 0;
        line-height: 10px;
        height: 10px;
        width: 40px;
        border-radius: 50vh;
        color: #999;
        border: 1px solid #ddd;
      }
    }
  }
}
@keyframes jumpout {
  0% {
    transform: translateY(calc(100vh));
  }
  100% {
    transform: translateY(calc(100vh - 110px));
  }
}
@keyframes ash {
  0% {
    opacity: 1;
    transform: translate(50%,100vh) scale(1.5);
  }
  100% {
    transform: translate(50%, calc(50vh - 50vw)) scale(.1);
    opacity: 0;
  }
}
</style>